import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Country } from 'src/app/entities/shared/Country';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbList = [
    {
      url: '/rds/:codeRegion',
      list: [{
        text: 'Configuración de RDS',
        url: '',
      }]
    },
    {
      url: '/visualizacion-logs/:codeRegion',
      list: [{
        text: 'Vizualización de logs',
        url: '',
      }]
    },
    {
      url: '/merge/:codeRegion',
      list: [{
        text: 'Merger',
        url: '',
      }]
    },
    {
      url: '/dissociate/:codeRegion',
      list: [{
        text: 'Disociar',
        url: '',
      }]
    },
    {
      url: '/seguimiento-reqid/:codeRegion',
      list: [{
        text: 'Seguimiento de RequestID',
        url: '',
      }]
    },
    {
      url: '/bulk/:codeRegion',
      list: [{
        text: 'Update / Delete Masivo',
        url: '',
      }]
    },
    {
      url: '/mantenedor/fuentes/interno/:codeRegion',
      list: [{
        text: 'Mantenedor de fuentes',
        url: '',
      }]
    },
    {
      url: '/mantenedor/fuentes/vip/:codeRegion',
      list: [{
        text: 'Mantenedor de fuentes VIP',
        url: '',
      }]
    },
    {
      url: '/mantenedor/buscador/interno/:codeRegion',
      list: [{
        text: 'Motor de búsqueda',
        url: '',
      }]
    },
    {
      url: '/mantenedor/buscador/vip/:codeRegion',
      list: [{
        text: 'Motor de búsqueda VIP',
        url: '',
      }]
    },
    {
      url: '/mantenedor/profile-region/:codeRegion',
      list: [{
        text: 'Profile Región',
        url: '',
      }]
    },
    {
      url: '/rds/fuentes/interno/:codeRegion',
      list: [{
        text: 'Mantenedor de fuentes RDS',
        url: '',
      }]
    },
    {
      url: '/dm/search/:codeRegion',
      list: [{
        text: 'Buscador de persona',
        url: '',
      }]
    },
    {
      url: '/data-maintenance/:codeRegion/fuentes',
      list: [{
        text: 'Buscador de persona',
        url: '/dm/search/:codeRegion',
      }, {
        text: 'Fuentes',
        url: '',
      }]
    },
    {
      url: '/data-maintenance/fuentes-rds/:codeRegion',
      list: [{
        text: 'RDS',
        url: '',
      }]
    },
    {
      url: '/data-maintenance/fuentes-rds/:codeRegion/:domain/:subDomain',
      list: [{
        text: 'RDS',
        url: '/data-maintenance/fuentes-rds/:codeRegion',
      }, {
        text: ':source',
        url: '',
      }]
    },
    {
      url: '/data-maintenance/:codeRegion/:domain/:subDomain',
      list: [{
        text: 'Buscador de persona',
        url: '/dm/search/:codeRegion',
      }, {
        text: 'Fuentes',
        url: '/data-maintenance/:codeRegion/fuentes',
      }, {
        text: ':source',
        url: '',
      }]
    }

  ];
  list: any = []
  currentCountry: string;
  sourceTitle: string = '';

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    if (this.localStorageService.getRegionSeleccionada === null) {
      const url = localStorage.getItem('urlReturn');
      this.router.navigateByUrl(url);
    }
    this.router.events.pipe(
      filter(
        event => event instanceof NavigationEnd
      )
    ).subscribe((event) => {
      // console.log("event ----->", event);
      this.list = [];
      this.breadcrumbGenerate(event);
    });

    // Suscribirse a actualizaciones del breadcrumb cuando cambian las configuraciones GFD
    this.localStorageService.getBreadcrumbUpdateObs.subscribe((shouldUpdate) => {
      if (shouldUpdate) {
        // Regenerar el breadcrumb con la URL actual
        const currentUrl = this.router.url;
        const event = { url: currentUrl };
        this.list = [];
        this.breadcrumbGenerate(event);
        console.log('[Breadcrumb] Actualizado por cambio en configuración GFD');
      }
    });
  }

  breadcrumbGenerate(event): void {
    this.localStorageService.regionSeleccionada.subscribe((country: Country) => {

      const countryCode = country ? country.getCode() : '';
      this.currentCountry = countryCode;
      const url = `/${event.url.split('/').slice(2).join('/')}`.toLowerCase();

      if (url.includes("search")) {
        this.localStorageService.setFilter = undefined;
        this.localStorageService.onFilterPreviewReset();
      }

      // Purposing viewer: /dm/purposing/:codeRegion/:team/:profile/:config
      const purposingMatch = url.match(/^\/dm\/purposing\/([^/]+)\/([^/]+)\/([^/]+)\/([^/]+)$/);
      if (purposingMatch) {
        const [, , , profile, config] = purposingMatch;
        const labelText = `${decodeURIComponent(profile)} / ${decodeURIComponent(config)}`;
        this.list = [
          { text: 'Buscador de persona', url: `/dm/search/${countryCode}` },
          { text: 'Fuentes', url: `/data-maintenance/${countryCode}/fuentes` },
          { text: labelText, url: '' },
        ];
        this.localStorageService.setListBreadcrumb = this.list;
        return;
      }

      this.breadcrumbList.forEach(breadcrumb => {
        const urlCompare = this.replaceUrlParams(breadcrumb.url, countryCode).toLowerCase();
        if (url === urlCompare) {
          this.list = this.generateLink(breadcrumb.list, countryCode);
          this.localStorageService.setListBreadcrumb = this.list;
        }
        if (breadcrumb.url.includes(':domain') && breadcrumb.url.includes(':subDomain')) {
          this.localStorageService.getMenuSelectedObs.subscribe(menu => {
            if (menu) {
              const { domainJO, subDomainJO, title } = menu;
              const fullUrlCompare = this.replaceUrlParams(breadcrumb.url, countryCode, domainJO, subDomainJO).toLowerCase();
              if (url === fullUrlCompare) {
                // Obtener la configuración seleccionada y si hay múltiples configs
                const selectedConfig = this.localStorageService.getSelectedGfdConfig;
                const hasMultipleConfigs = this.localStorageService.getHasMultipleGfdConfigs;
                // Solo pasar estos parámetros si estamos en la ruta correcta Y hay múltiples configuraciones
                this.list = this.generateLink(breadcrumb.list, countryCode, title, selectedConfig, hasMultipleConfigs);
                this.localStorageService.setListBreadcrumb = this.list;
              }
            }
          })
        }
      })
    })
  }

  replaceUrlParams(url: string, countryCode: string, domainJO?: string, subDomainJO?: string) {
    let newUrl = url.replace(':codeRegion', countryCode);
    if (domainJO && subDomainJO) {
      newUrl = newUrl.replace(':domain', domainJO).replace(':subDomain', subDomainJO).toLowerCase();
    }
    return newUrl;
  }


  generateLink(list: any[], country: string, title?: string, selectedConfig?: string, hasMultipleConfigs?: boolean) {
    const newList = list.map(item => {
      const newItem = { ...item };
      if (newItem.url && newItem.url.includes(':codeRegion')) {
        newItem.url = newItem.url.replace(':codeRegion', country);
      }
      if (title && newItem.text.includes(':source')) {
        newItem.text = newItem.text.replace(':source', title);
      }
      return newItem;
    });

    // Debug log
    if (title) {
      console.log('[Breadcrumb] generateLink called:', {
        title,
        selectedConfig,
        hasMultipleConfigs,
        listLength: newList.length
      });
    }

    // Ya no mostramos el nombre de la configuración en el breadcrumb
    // Siempre mostramos solo: Buscador de persona > Fuentes > [Nombre de la fuente]
    return newList;
  }

  goToHome() {
    if (!this.localStorageService.getIsExternoRDS) {
      this.localStorageService.setMenuApp = null;
      this.router.navigateByUrl(
        this.localStorageService.getIsVip
          ? environment.URL_RETURN_APP_VIP
          : this.localStorageService.getIsExternoRDS
            ? environment.URL_RETURN_APP_RDS
            : environment.URL_RETURN_APP
      );
    }
  }

  naviteURL(item: any) {
    // Si es un string (compatibilidad con código antiguo), convertirlo a objeto
    const breadcrumbItem = typeof item === 'string' ? { text: item, url: '', action: null } : item;

    // console.log('naviteURL item', breadcrumbItem);

    // Si tiene una acción especial (como volver al selector de config)
    if (breadcrumbItem.action === 'backToConfigSelection') {
      // Emitir evento para que el componente fuente-dinamica vuelva a la selección de config
      this.localStorageService.onBackToConfigSelection();
      return;
    }

    if (!(this.localStorageService.getIsExternoRDS || this.localStorageService.esAltaEntidades)) {
      let url = "";
      let stringUrlSource = (this.localStorageService.getIsVip)
        ? 'vip/data-maintenance'
        : (this.localStorageService.getIsExternoRDS)
          ? 'rdsportal/data-maintenance'
          : 'int/data-maintenance';

      const type = breadcrumbItem.text;
      if (type.toLocaleLowerCase() === 'fuentes') {
        url = `/${stringUrlSource}/${this.currentCountry}/fuentes`;
      }
      if (type.toLocaleLowerCase() === 'rds') {
        url = `/${stringUrlSource}/fuentes-rds/${this.currentCountry}`;
      }
      if (type.toLocaleLowerCase() === 'buscador de persona') {
        this.localStorageService.setFilter = undefined;
        this.localStorageService.onFilterPreviewReset();
        url = `/${this.localStorageService.getIsVip
          ? 'vip'
          : this.localStorageService.getIsExternoRDS
            ? 'rdsportal'
            : 'int'}/dm/search/${this.currentCountry}`;
      }
      this.router.navigateByUrl(url);
    }
  }
}
